import React from 'react';
import { withTheme } from '@ifit/themes/withTheme';
import { withTranslation, II18n } from '@ifit/rapport-webview';
import raportPackage from './rapport-web.json';
import formatters from './formatters';
import './index.scss';

interface IProps {
  estimates: {
    time: number | string;
    distance: number | string;
    calories: number | string;
  };
  limit: number;
  useMetricUnits: boolean;
  equipmentType: string;
  iconColor: string;
  themeClass: string;
  i18n: II18n;
}

const metrics = ['time', 'distance', 'calories'];

export const Estimates = ({
  estimates,
  limit,
  iconColor,
  useMetricUnits,
  equipmentType,
  themeClass,
  i18n,
}: IProps) => {
  if (!estimates) {
    return null;
  }
  const dataNodes = metrics
    .filter(type => estimates[type])
    .filter((_, index) => !limit || limit > index)
    .map(type => {
      const value = estimates[type];
      const formatterFn = formatters(i18n)[type];
      const shouldFormatValue = formatterFn && typeof value !== 'string';
      const displayValue = shouldFormatValue
        ? formatterFn(value, useMetricUnits, equipmentType)
        : value;
      return (
        <React.Fragment key={type}>
          <span className="icon" style={{ color: iconColor }}>
            {type[0].toUpperCase()}
          </span>
          <span className="value">{displayValue}</span>
        </React.Fragment>
      );
    });

  return <div className={`estimates ${themeClass}`}>{dataNodes}</div>;
};

export default withTheme(withTranslation(raportPackage)(Estimates));
export { formatters };
